import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Link from 'gatsby-link'
import { MOBILE_MEDIA_QUERY } from 'typography-breakpoint-constants'

import style from '../utils/styles'
import { rhythm } from '../utils/typography'
import {Container} from './layouts'

import logo from '../assets/logo.jpg'
import iconEmail from '../assets/icon-email.jpg'
import iconPhone from '../assets/icon-phone.jpg'

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  height: ${rhythm(6)};

  @media (max-width: 400px) {
    flex-flow: column;
    height: auto;
    align-items: flex-start;
  }

  @media (min-width: 401px) and (max-width: 800px) {
    flex-wrap: wrap;
  }
`
const Logo = styled.div`
  margin-right: auto;
  width: 100%;
  & img {
    margin-bottom: auto;
  }
  @media (max-width: 400px) {
    margin-top: ${rhythm(1)};
  }
`

const ContactBlock = styled.div`
  width: 300px;
  display: flex;
  align-items: center;
  margin-left: ${rhythm(1)};

  @media (max-width: 400px) {
    margin-left: 0;
  }


  & img {
    margin: auto 0 auto auto;
    width: 43px;
    height: 40px;
  }

  & .info {
    color: ${style.green};
    margin-left: ${rhythm(0.5)};
    display: flex;
    flex-flow: column;
  }

  & a {
    text-decoration: none;
    font-weight: bold;
    color: black;
  }
`

const MainMenu = styled.div`
  background-color: ${style.green};

  @media (min-width: 800px) {
    height: ${rhythm(3)};
  }
`

const MenuUl = Container.withComponent('ul').extend`
  display: flex;
  flex-flow: column;

  @media (min-width: 400px) {
    align-items: stretch;
    flex-flow: row;
    height: 100%;
  }

  @media (min-width: 400px) and (max-width: 799px) {
    flex-flow: wrap;
  }

  & li {
    list-style: none;
    flex-grow: 1;
    display: flex;
    margin-bottom: 0;

    @media (min-width: 400px) and (max-width: 799px) {
      width: 200px;
    }

    @media (max-width: 799px) {
      height: ${rhythm(2)};
    }
  }

  & a {
    color: white;
    font-style: normal;
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: center;
    text-decoration: none;
    margin: 0 auto;
    width: 90%;
    transition: all 150ms ease-in-out;


    &:hover,
    &:focus,
    &:active,
    &.active {
      width: 100%;
      background-color: white;
      color: ${style.green};
    }
  }
`

class Header extends React.Component {
  render() {
    const {isHome} = this.props



    return (
      <div>
        <Container>
          <HeaderContainer>
            <Logo>
              {isHome
                ? <img src={logo} alt="Kirstilouko" className="logo"/>
                :  <Link to="/">
                    <img src={logo} alt="Kirstilouko" className="logo"/>
                  </Link>
              }
            </Logo>
            <ContactBlock>
              <img src={iconEmail} alt="Email icon" />
              <div className="info">
                <span className="title">Lähetä sähköpostia</span>
                <a href="mailto:info@kirstilouko.com">info@kirstilouko.com</a>
              </div>
            </ContactBlock>
            <ContactBlock>
              <img src={iconPhone} alt="Phone icon" />
              <div className="info">
                <span className="title">Soita</span>
                <a href="tel:050-5288861">050-5288861</a>
              </div>
            </ContactBlock>


          </HeaderContainer>
        </Container>
        <MainMenu>
          <MenuUl>
            <li><Link to="/">ETUSIVU</Link></li>
            <li><Link to="/psykoterapia" activeClassName="active">PSYKOTERAPIA</Link></li>
            {/* <li><Link to="/nettiterapia" activeClassName="active">NETTITERAPIA</Link></li> */}
            <li><Link to="/seksuaalineuvonta" activeClassName="active">SEKSUAALINEUVONTA</Link></li>
            <li><Link to="/tyonohjaus" activeClassName="active">TYÖNOHJAUS</Link></li>
            <li><Link to="/hinnasto" activeClassName="active">HINNASTO</Link></li>
            <li><Link to="/yhteystiedot" activeClassName="active">YHTEYSTIEDOT</Link></li>
          </MenuUl>
        </MainMenu>
      </div>
    )
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/layouts/header.js